import { FacetId } from '@grandvisionhq/search';
import { getContentByRef } from './get-content-by-ref.js';

/**
 * This function is only used in opco sites to configure Algolia on the server.
 */ function getAlgoliaConfigFromBloomreach(pageModel, refPrefix) {
    var // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref, ref1, ref2, ref3;
    if (!pageModel) {
        return {
            isEnabled: false
        };
    }
    const component = Object.values(pageModel.page).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (value)=>value.label === 'Product catalog v2'
    );
    const content = getContentByRef((ref = (component)) === null || ref === void 0 ? void 0 : (ref1 = ref.models) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.document) === null || ref2 === void 0 ? void 0 : ref2.$ref, pageModel, refPrefix);
    const isEnabled = !!component;
    const presetQueryString = getPresetQueryString(content);
    var ref4;
    const ruleContexts = (ref4 = content === null || content === void 0 ? void 0 : (ref3 = content.data) === null || ref3 === void 0 ? void 0 : ref3.ruleContexts) !== null && ref4 !== void 0 ? ref4 : [];
    const isPrescriptionGlasses = presetQueryString.toLowerCase().includes('frames') || presetQueryString.toLowerCase().includes('sunglasses');
    const facetingAfterDistinct = !isPrescriptionGlasses;
    return {
        isEnabled,
        presetQueryString,
        ruleContexts,
        facetingAfterDistinct
    };
}
function getPresetQueryString(content) {
    if (!(content === null || content === void 0 ? void 0 : content.data)) {
        return '';
    }
    let presetQueryString = (content.data.filterQuery || '').split('#')[0];
    const categoryExternalId = content.data.categoryExternalId || '';
    if (categoryExternalId) {
        const symbol = presetQueryString.includes('?') ? '&' : '?';
        presetQueryString += symbol + `${FacetId.categoryExternalId}=${categoryExternalId}`;
    }
    return presetQueryString;
}

export { getAlgoliaConfigFromBloomreach };
//# sourceMappingURL=get-algolia-config-from-bloomreach.js.map
